import { AnpReportsTransformer } from "./anpReportsTransformer";

export class AnpHistoricalReportsTransformer {
  static tableTransformer() {
    return AnpReportsTransformer.tableTransformer({
      basePath: '/anp-historical-reports',
      showActions: true,
      operationKlass: "Establishment::Anp::HistoricalReports::Show"
    });
  }
}
